import React from 'react';
import { whyChooseUs } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Shield, DollarSign, Zap, Headphones, ShoppingCart, Globe } from 'lucide-react';

const featureIcons = [Shield, DollarSign, Zap, Headphones, ShoppingCart, Globe];

const FeatureCard = ({ item, idx }) => {
  const card = useScrollAnimation({ threshold: 0.1 });
  const Icon = featureIcons[idx];
  const isEven = idx % 2 === 0;

  return (
    <div
      ref={card.ref}
      data-testid={`why-choose-card-${item.id}`}
      className={`group bg-white rounded-2xl p-7 border border-zinc-100 transition-all duration-500 hover:shadow-[0_20px_50px_rgba(124,58,237,0.15)] hover:-translate-y-2 scroll-fade-up scroll-delay-${(idx % 3) + 1} ${card.isVisible ? 'scroll-visible' : ''}`}
    >
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-colors duration-500 ${
        isEven ? 'bg-[#7C3AED]/10 group-hover:bg-[#7C3AED]' : 'bg-[#14B8A6]/10 group-hover:bg-[#14B8A6]'
      }`}>
        <Icon className={`w-6 h-6 transition-colors duration-500 ${
          isEven ? 'text-[#7C3AED] group-hover:text-white' : 'text-[#14B8A6] group-hover:text-white'
        }`} />
      </div>
      <h4 className="text-base font-bold text-zinc-900 mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
        {item.title}
      </h4>
      <p className="text-sm text-zinc-500 leading-relaxed">
        {item.description}
      </p>
    </div>
  );
};

const WhyChooseUsSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });

  return (
    <section data-testid="why-choose-section" className="py-24 md:py-32 relative overflow-hidden" style={{
      background: 'linear-gradient(180deg, #f0fdf9 0%, #f5f3ff 100%)'
    }}>
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#7C3AED]/10 text-[#7C3AED] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide mb-4">
            WHY CHOOSE US
          </span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-zinc-900 leading-tight mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            The Right Partner for Brand Protection
          </h2>
          <p className="text-base text-zinc-500 leading-relaxed">
            Trusted by thousands of businesses for expert trademark registration and federal brand protection nationwide.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyChooseUs.map((item, idx) => (
            <FeatureCard key={item.id} item={item} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
